document.addEventListener("DOMContentLoaded", function () {
  const keywords = ["Backpacks", "Tote Bag", "Handbags", "Travel Bags", "Sling Bags"];
  const label = document.querySelector('.m-search-form__label');

  if (!label) return;

  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  const typingSpeed = 100;
  const deletingSpeed = 50;
  const pauseAfterType = 1500;
  const pauseAfterDelete = 300;

  function type() {
    const currentWord = keywords[wordIndex];

    if (!isDeleting) {
      label.textContent = currentWord.substring(0, charIndex + 1);
      charIndex++;

      if (charIndex === currentWord.length) {
        isDeleting = true;
        setTimeout(type, pauseAfterType);
        return;
      }
    } else {
      label.textContent = currentWord.substring(0, charIndex - 1);
      charIndex--;

      if (charIndex === 0) {
        isDeleting = false;
        wordIndex = (wordIndex + 1) % keywords.length;
        setTimeout(type, pauseAfterDelete);
        return;
      }
    }

    setTimeout(type, isDeleting ? deletingSpeed : typingSpeed);
  }

  type();
});